import { render } from "./StoreAccessControl.vue?vue&type=template&id=3b90b145"
import script from "./StoreAccessControl.vue?vue&type=script&lang=js"
export * from "./StoreAccessControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__